import { mediaLibrary } from "./project_modules/media-library";
import { menu } from "./project_modules/menu";

const htmlWidth = window.innerWidth

const BREAKPOINT_MOBILE = 575;
const BREAKPOINT_TABLET = 768;
const BREAKPOINT_DESKTOP = 992;
const BREAKPOINT_WIDESCREEN = 1350;

menu();
mediaLibrary();